import { render, staticRenderFns } from "./MobileItemsRow.vue?vue&type=template&id=3a4544ec&scoped=true"
import script from "./MobileItemsRow.vue?vue&type=script&lang=js"
export * from "./MobileItemsRow.vue?vue&type=script&lang=js"
import style0 from "./MobileItemsRow.vue?vue&type=style&index=0&id=3a4544ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4544ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a4544ec')) {
      api.createRecord('3a4544ec', component.options)
    } else {
      api.reload('3a4544ec', component.options)
    }
    module.hot.accept("./MobileItemsRow.vue?vue&type=template&id=3a4544ec&scoped=true", function () {
      api.rerender('3a4544ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MobileItemsRow.vue"
export default component.exports